import {
  UNBLOCKCUSTOMEROPERATIONLIST_SUCCESS,
  UNBLOCKCUSTOMEROPERATIONLIST_FAILED,
  RESET_UNBLOCKCUSTOMEROPERATIONLIST,
  LOADING_UNBLOCKCUSTOMEROPERATIONLIST,
  NETWORK_ERROR_UNBLOCKCUSTOMEROPERATIONLIST,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  nvalidRequest: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UNBLOCKCUSTOMEROPERATIONLIST: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case UNBLOCKCUSTOMEROPERATIONLIST_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case UNBLOCKCUSTOMEROPERATIONLIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }

    case RESET_UNBLOCKCUSTOMEROPERATIONLIST: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
